import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ContractService } from '@app/features/contracts/contract-service';
import { Contract } from '@app/features/contracts/contract.model';
import { LayoutService } from '@app/nav/layout/layout.service';
import { securitySocialNumberValidator } from '@app/shared/forms/social-security.validator';
import { SsnFormatterDirective } from '@app/shared/forms/ssn-formatter.directive';
import { Observable, switchMap } from 'rxjs';
import { DocumentForm } from '../document-form/document-form';
import { CdTDocument } from '../document.model';

@Component({
  selector: 'app-social-security-document-and-number',
  imports: [
    MatFormFieldModule,
    DocumentForm,
    ReactiveFormsModule,
    MatInputModule,
    SsnFormatterDirective,
  ],
  templateUrl: './social-security-document-and-number.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./social-security-document-and-number.scss'],
})
export class SocialSecurityDocumentAndNumber {
  contract = input.required<Contract>();

  contractService = inject(ContractService);
  layoutService = inject(LayoutService);

  form = new FormGroup({
    socialSecurityCertificate: new FormControl<CdTDocument[]>([], { nonNullable: true }),
    socialSecurityNumber: new FormControl<string | null>(null, {
      validators: securitySocialNumberValidator(false),
    }),
  });

  constructor() {
    effect(() => {
      this.form.controls.socialSecurityNumber.setValue(
        this.contract().employee.socialSecurityNumber ?? '',
      );
    });
  }
  onDocumentUploaded($event: CdTDocument) {
    this.layoutService.previewDocument($event);
  }

  addDocumentToContractAndUpdateSSNumber(): Observable<Contract> | undefined {
    if (this.form.invalid) {
      return;
    }

    const socialSecurityNumber = this.form.controls.socialSecurityNumber.value ?? '';
    const contractId = this.contract().id!;
    return this.contractService
      .addDocument(contractId, {
        tag: 'socialSecurityCertificate',
        id: this.form.controls.socialSecurityCertificate.value[0].id,
      })
      .pipe(
        switchMap(() =>
          this.contractService.updateSocialSecurityNumber(contractId, socialSecurityNumber),
        ),
      );
  }
}
